import { IconProps } from './index';

const ArrowLeftSLine: React.VFC<IconProps> = ({ title, titleId, ...props }) => {
    return (
        <svg
            width="1em"
            height="1em"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                d="M9.024 10l4.125 4.125-1.179 1.178L6.667 10l5.303-5.303 1.179 1.178L9.024 10z"
                fill="currentColor"
            />
        </svg>
    );
};

export default ArrowLeftSLine;
